import React, { Component } from 'react';
import Button from '../../components/button';
export default class FindAPet extends Component {
    login() { console.log('loginin') }

    render() {
        return (
            <div className='find-a-pet-screen'>
                <div className="heading">Find a pet.</div>
                <div className="sub-heading">Please select what you want to do today.</div>
                <div className="controls">
                    <Button text='Create account' action={() => { console.log('im pressed') }} />
                    <Button text='Lend a pet' action={this.login.bind(this)} />
                    <Button text='Buy a pet' action={() => { }} />
                </div>
            </div>
        );
    }
}
